// src/components/Services.js
import React from "react";
import { Link } from "react-router-dom";
import { services } from "../servicesData";

const Services = () => {
  return (
    <section id="service" className="section bg-white py-20">
      <div className="container mx-auto px-6">
        {/* Services Grid */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <div
              key={s.slug}
              className="bg-[#f8f3ec] rounded-2xl shadow-md p-8 hover:shadow-lg transition duration-300"
            >
              <div className="flex flex-col items-start">
                {s.icon}
                <h3 className="text-xl font-semibold mb-2 text-primary">
                  {s.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {s.blurb}
                </p>
                <ul className="text-gray-700 text-sm space-y-1 list-disc pl-5 mb-4">
                  {s.bullets.map((b, idx) => (
                    <li key={idx}>{b}</li>
                  ))}
                </ul>

                {/* Link to detail page */}
                <Link
                  to={`/services/${s.slug}`}
                  className="text-accent font-semibold text-sm hover:underline"
                >
                  View details & pricing →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
